/*
  GCC delivery countdown (snippets/gcc-delivery.liquid). Before the cut-off hour in Dubai time (Asia/Dubai, no
  daylight saving) the line reads e.g. "Order within 2h 14m for same-day delivery in Dubai"; after it, the
  "tomorrow" text. Recomputed every 30 seconds and whenever the cart re-renders the element.
*/
(() => {
  const dubaiNow = () => {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    const get = (t) => Number((parts.find((p) => p.type === t) || {}).value || 0);
    return get('hour') * 60 + get('minute');
  };

  const escape = (value) => value.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* The visitor's emirate, asked once per browser session from our own lookup (no third party, nothing stored
     server side). Until it answers, or when it says anything but Dubai, the UAE line stays. */
  let emirate = null;
  try { emirate = sessionStorage.getItem('gcc_emirate'); } catch (e) {}
  const first = document.querySelector('[data-gcc-delivery][data-geo-url]');
  if (emirate === null && first && first.getAttribute('data-geo-url')) {
    fetch(first.getAttribute('data-geo-url'), { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => {
        emirate = (d && d.emirate) || '';
        try { sessionStorage.setItem('gcc_emirate', emirate); } catch (e) {}
        drawAll();
      })
      .catch(() => {});
  }

  const draw = () => {
    /* hide the promise while the chosen size is sold out (button has .sold_out) */
    const soldOut = !!document.querySelector('.product-details .addToCart.sold_out, .addToCart.sold_out');
    document.querySelectorAll('.gcc-delivery--product').forEach((el) => { el.hidden = soldOut; });
    document.querySelectorAll('[data-gcc-delivery]').forEach((el) => {
      if (emirate !== 'Dubai') return;
      const cutoff = (Number(el.getAttribute('data-cutoff')) || 16) * 60;
      const now = dubaiNow();
      const text = el.querySelector('[data-gcc-delivery-text]');
      if (!text) return;
      let html;
      if (now < cutoff) {
        const left = cutoff - now;
        const h = Math.floor(left / 60);
        const m = left % 60;
        const time = h > 0 ? `${h}h ${m}m` : `${m}m`;
        html = escape(el.getAttribute('data-text-before') || '').replace('[time]', `<strong>${time}</strong>`).replace('[cutoff]', String(cutoff / 60));
      } else {
        html = escape(el.getAttribute('data-text-after') || '').replace('[cutoff]', String(cutoff / 60));
      }
      /* write only on a change: the observer below would otherwise wake itself up forever */
      if (text.getAttribute('data-gcc-html') === html) return;
      text.setAttribute('data-gcc-html', html);
      text.innerHTML = html;
    });
  };


  /* Dubai promotion (29 Sep, Adam: "show same-day delivery much more on the whole website"). Only for visitors our
     lookup places in Dubai (same rule as before). Everything is drawn from here so it follows the same clock:
     - announcement bar: live countdown message instead of the rotating texts
     - home hero eyebrow: "Delivered today in Dubai"
     - product page + cart: the delivery line gets a stronger, premium style
     Before the cut-off: "today"; after it: "tomorrow". */
  const TRUCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/></svg>';
  const GCC_OTHER = ['SA', 'KW', 'QA', 'BH', 'OM'];
  const countryName = (c) => { try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(c); } catch (e) { return c; } };
  /* Three audiences, each with its own strongest promise (Adam 29 Sep: "get it today", push same-day, sell harder):
     Dubai -> "Get it today" (live countdown) · rest of UAE -> "Get it in 1–2 days" · other GCC -> "Get it in 1–4 days". */
  const promo = () => {
    const root = document.documentElement;
    const cc = (window.Shopify && Shopify.country) || '';
    let seg = '';
    if (cc === 'AE') { if (emirate === null) return; seg = emirate === 'Dubai' ? 'dubai' : 'uae'; }
    else if (GCC_OTHER.indexOf(cc) > -1) seg = 'gcc';
    if (!seg) { root.classList.remove('ns-promo', 'ns-dubai'); return; }
    const src = document.querySelector('[data-gcc-delivery][data-cutoff]');
    const cutoff = (Number(src && src.getAttribute('data-cutoff')) || 16) * 60;
    const now = dubaiNow(), today = now < cutoff;
    const left = cutoff - now, h = Math.floor(left / 60), m = left % 60;
    const time = h > 0 ? `${h}h ${m}m` : `${m}m`;
    const name = countryName(cc);
    const copy = {
      dubai: today
        ? { ann: `<b>Same-day delivery in Dubai</b> · order within <b>${time}</b>`, hero: '', eyebrow: 'Delivered today · Dubai' }
        : { ann: '<b>Next-day delivery in Dubai</b> · order now', hero: '', eyebrow: 'Delivered tomorrow · Dubai' },
      uae: { ann: '<b>Get it in 1–2 days</b> anywhere in the UAE · same-day in Dubai', hero: 'Delivered in 1–2 days across the UAE', eyebrow: 'Fast UAE delivery' },
      gcc: { ann: `<b>Get it in 1–4 days in ${name}</b> · shipped from Dubai`, hero: `Delivered to ${name} in 1–4 days`, eyebrow: `Express delivery · ${name}` }
    }[seg];
    root.classList.add('ns-promo');
    root.classList.toggle('ns-dubai', seg === 'dubai');
    root.setAttribute('data-ns-seg', seg);
    root.style.setProperty('--ns-eyebrow', JSON.stringify(copy.eyebrow));
    const row = document.querySelector('.announcement .announcement-row');
    if (row) {
      let el = row.querySelector('.ns-dubai-ann');
      if (!el) { el = document.createElement('a'); el.className = 'announcement-content ns-dubai-ann'; el.href = '/collections/all'; row.appendChild(el); }
      const html = `${TRUCK}<span>${copy.ann}</span>`;
      if (el.getAttribute('data-h') !== html) { el.setAttribute('data-h', html); el.innerHTML = html; }
    }
    /* Dubai: big same-day block in the home hero, right above the button */
    document.querySelectorAll('.hero-section .hero-content-inner').forEach((box) => {
      let el = box.querySelector('.ns-hero-sameday');
      if (seg !== 'dubai') { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div'); el.className = 'ns-hero-sameday';
        const btn = box.querySelector('.btn, a');
        if (btn) box.insertBefore(el, btn); else box.appendChild(el);
      }
      const html = today
        ? `<i class="ns-hs-dot"></i><span><b>Same-day delivery</b> in Dubai</span><i class="ns-hs-sep"></i><span class="ns-hs-t">${time} left</span>`
        : `<i class="ns-hs-dot"></i><span><b>Next-day delivery</b> in Dubai</span><i class="ns-hs-sep"></i><span class="ns-hs-t">order now</span>`;
      if (el.getAttribute('data-h') !== html) { el.setAttribute('data-h', html); el.innerHTML = html; }
    });
    document.querySelectorAll('.hero-section .hero-subheading').forEach((el) => {
      if (!el.hasAttribute('data-orig')) el.setAttribute('data-orig', el.textContent);
      const t = seg === 'dubai' ? el.getAttribute('data-orig') : copy.hero;   /* Dubai has its own hero line */
      if (el.textContent !== t) el.textContent = t;
    });
  };
  const drawAll = () => { draw(); promo(); };
  drawAll();
  setInterval(drawAll, 30000);
  /* the cart drawer re-renders its HTML: pick up a fresh [data-gcc-delivery] once per frame at most */
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      drawAll();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
